function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_217",
  "data-name": "Rectangle 217",
  width: 26,
  height: 26,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2195",
  "data-name": "Path 2195",
  d: "M21.5,18.67H4.5a.8.8,0,0,1-.8-.8V15.236a.731.731,0,0,1,.585-.726,1.537,1.537,0,0,0,0-3.021.731.731,0,0,1-.585-.725V8.129a.8.8,0,0,1,.8-.8h17a.8.8,0,0,1,.8.8v2.635a.73.73,0,0,1-.584.725,1.537,1.537,0,0,0,0,3.021.73.73,0,0,1,.585.726v2.635a.8.8,0,0,1-.8.8M7.92,17.121a.3.3,0,1,1,.6,0v.95H21.5a.2.2,0,0,0,.2-.2V15.236a.136.136,0,0,0-.1-.136,2.138,2.138,0,0,1,0-4.2.135.135,0,0,0,.1-.135V8.129a.2.2,0,0,0-.2-.2H8.52v.95a.3.3,0,0,1-.6,0v-.95H4.5a.2.2,0,0,0-.2.2v2.635a.134.134,0,0,0,.1.135,2.138,2.138,0,0,1,0,4.2.136.136,0,0,0-.1.136v2.635a.2.2,0,0,0,.2.2H7.92Zm.6-2.748V11.626a.3.3,0,0,0-.6,0v2.747a.3.3,0,0,0,.6,0"
});

function SvgIconCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_coupon",
    "data-name": "icon - coupon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoupon);
export default __webpack_public_path__ + "static/media/icon-coupon.f01023c2.svg";
export { ForwardRef as ReactComponent };